<template>
  <div>
    <a-table :columns="columns" :dataSource="data" size="middle" :pagination="pagination" @change="tableChange" :rowClassName="classFun" :loading="loading"></a-table>
  </div>
</template>

<script>
import { http } from '@/utils/http'

export default {
  name: 'DayiHistory',
  data() {
    return {
      columns: [
        {
          title: '编号',
          dataIndex: 'index',
          align: 'center',
          width: 80
        },
        {
          title: '时间',
          dataIndex: 'jsrq',
        },
        {
          title: '时长（时）',
          dataIndex: 'shics',
        },
        {
          title: '检测项目',
          dataIndex: 'jiancxm',
        },
        {
          title: '检测科室',
          dataIndex: 'genreCode',
        },
        {
          title: '收费',
          dataIndex: 'shijsf',
        },
        {
          title: '操作人',
          dataIndex: 'yhname',
        },
        {
          title: '操作内容',
          dataIndex: 'remarks',
        },
      ],
      data: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true,
      },
      loading: false
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      let parameter = {
        assetId: this.$route.query.id,
        pageNum: 1,
        pageSize: this.pagination.pageSize
      }
      this.loading = true
      http('/reservation/orderHistory', 'POST', parameter).then(res => {
        this.loading = false
        if (res.success) {
          let data = res.data
          this.pagination.total = data.total
          data.resultList.forEach((item, i) => {
            item.index = (this.pagination.current - 1) * 10 + i + 1
            item.key = item.id
          })
          this.data = data.resultList
        }
      })
    },
    // 表格行类名方法
    classFun(record) {
      if (record.index % 2 == 0) return 'gray'
    },
    // 表格分页事件
    tableChange(pagination) {
      this.pagination.current = pagination.current
      this.getDetail()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-table-pagination.ant-pagination li {
  margin-left: 14px;
}
/deep/ .gray {
  background: #F7F7F7;
}
/deep/ .ant-table-thead {
  background: #F2F2F2;
}
</style>